var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircularEconomy = function SvgCircularEconomy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 60,
    r: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M66 39c0-.77 0-3-9-4.68V16a7 7 0 0 0-7-7H30a7 7 0 0 0-7 7v18.32C14 36 14 38.23 14 39c0 2.37 4.19 3.8 9 4.67V64a7 7 0 0 0 7 7h20a7 7 0 0 0 7-7V43.67c4.81-.87 9-2.3 9-4.67m-50 0c0-.28 1.28-1.57 7-2.65v5.3c-4.81-.92-7-2.07-7-2.65m39 25a5 5 0 0 1-5 5H30a5 5 0 0 1-5-5V44c3.63.53 7.35.78 9.71.89L30.64 49a1 1 0 0 0 0 1.41 1 1 0 0 0 .7.3 1 1 0 0 0 .71-.3l5.66-5.65A1 1 0 0 0 38 44a1 1 0 0 0-.4-.8l-5.55-5.55a1 1 0 0 0-1.41 1.41l3.82 3.83A87 87 0 0 1 25 42V16a5 5 0 0 1 5-5h20a5 5 0 0 1 5 5v26a93 93 0 0 1-12 1 1 1 0 0 0-1 1 1 1 0 0 0 1 1 107 107 0 0 0 12-1Zm2-22.35v-5.3c5.72 1.08 7 2.37 7 2.65 0 .58-2.19 1.73-7 2.65"
  })));
};
export default SvgCircularEconomy;